import { ArrayMappable, Model } from '@team-decorate/alcjs'
import linq from 'linq'
import User from './User'
import OrderItem from './OrderItem'
import OrderDeliveryAddress from './OrderDeliveryAddress'
import UserAddress from './UserAddress'
import Coupon from './Coupon'
import { dateFormat } from '../utility/dateUtility'
import OrderConstant, {
    ORDER_STATUS_LIST,
    USER_ORDER_ORDER_STATUS_LIST,
} from '../const/OrderConstant'
import OrderNotListItem from './OrderNotListItem'

const FILLABLE = [
    'id',
    'orderId',
    'couponId',
    'userId',
    'version',
    'userName',
    'userEmail',
    'userPhone',
    'orderCompanyName',
    'paymentName',
    'usageDate',
    'usageName',
    'usageDetail',
    'deliveryDate',
    'deliveryTimeSpecified',
    'deliveryTimeDetail',
    'deliveryPersonName',
    'deliveryPersonTel',
    'deliveryTargetPhoneNumber',
    'deliveryMethod',
    'deliveryTargetOther',
    'returnDate',
    'returnTimeSpecified',
    'returnTimeDetail',
    'returnPersonName',
    'returnPersonTel',
    'returnMethod',
    'returnTargetOther',
    'remarks',
    'totalPriceJpy',
    'discountPriceJpy',
    'boxCount',
    'shippingFee',
    'workingExpenses',
    'discountTotalPriceJpy',
    'status', // ステータス
    'responsiblePersonName', // 担当者名(管理者)
    'updatedUserType', // 最後に編集した人
    'quoteExpirationDate', // 見積有効期限
    'orderPeriodDate', // 発注期限
    'fixedDate', // 最終数量確定日
    'fixedDueDate', // 最終数量確定期日
    'paymentDueDate', // ご入金予定日
    'deliveryDueDate', // 納品予定日
    'rentalPeriod', // レンタル期間
    'extendedDate', // 延長後の返却日
    'purchaseOrderRemarks', // 発注書備考
    'quoteRemarks', // 見積書備考
    'isStockCheckOnly', // 在庫確認のみ
    'usagePrefecture', // ご利用都道府県
    'createdAt',
    'updatedAt',
    'orderItems',
    'orderNotListItems',
    'orderUserAddress',
    'orderDeliveryAddress',
    'carriedSupport',
    'carryOutSupport',
    'customerCode',
]

const PRESENTS = [
    'couponId',
    'version',
    'orderCompanyName',
    'paymentName',
    'usageName',
    'usageDetail',
    'deliveryTimeSpecified',
    'deliveryTimeDetail',
    'deliveryPersonName',
    'deliveryPersonTel',
    'deliveryTargetOther',
    'returnTimeSpecified',
    'returnTimeDetail',
    'returnPersonName',
    'returnPersonTel',
    'returnTargetOther',
    'remarks',
    'boxCount',
    'shippingFee',
    'discountPriceJpy',
    'isStockCheckOnly',
    'workingExpenses',
    'carriedSupport',
    'carryOutSupport',
    'customerCode',
    'createdAt',
    'updatedAt',
]

export const USAGE_NAME_WEDDING = '0'
export const USAGE_NAME_SHOOTING = '1'
export const USAGE_NAME_EVENT = '2'
export const USAGE_NAME_PARTY = '3'
export const USAGE_NAME_OTHER = '4'
export const USAGE_NAME_LIST = [
    { name: '婚礼', value: USAGE_NAME_WEDDING },
    { name: '撮影', value: USAGE_NAME_SHOOTING },
    { name: 'イベント', value: USAGE_NAME_EVENT },
    { name: 'パーティー', value: USAGE_NAME_PARTY },
    { name: 'その他', value: USAGE_NAME_OTHER },
]

// 納品方法
export const DELIVERY_METHOD_DELIVER_YAMATO = 'deliver_yamato' // 宅配 ヤマト運輸
export const DELIVERY_METHOD_DELIVER_SAGAWA = 'deliver_sagawa' // 宅配 佐川急便
export const DELIVERY_METHOD_DELIVER_CHARTER = 'deliver_charter' // 宅配 チャーター便
export const DELIVERY_METHOD_DELIVER_OWN = 'deliver_own' // ルート便（契約者のみ）
export const DELIVERY_METHOD_RECEIVER_YOKOHAMA = 'receiver_yokohama' // 店舗受け取り 横浜
export const DELIVERY_METHOD_RECEIVER_OSAKA = 'receiver_osaka' // 店舗受け取り 大阪
export const DELIVERY_METHOD_RECEIVER_TOKYO_SHOWROOM = 'receiver_tokyo_showroom' // 店舗受け取り 東京ショールーム
export const DELIVERY_METHOD_RECEIVER_OSAKA_SHOWROOM = 'receiver_osaka_showroom' // 店舗受け取り 大阪ショールーム

export const DELIVERY_METHOD_TYPE_LIST = [
    { value: DELIVERY_METHOD_DELIVER_SAGAWA, name: '宅配 佐川急便' },
    { value: DELIVERY_METHOD_DELIVER_YAMATO, name: '宅配 ヤマト運輸' },
    { value: DELIVERY_METHOD_DELIVER_CHARTER, name: 'チャーター便' },
    { value: DELIVERY_METHOD_DELIVER_OWN, name: 'ルート便（契約者のみ）' },
    { value: DELIVERY_METHOD_RECEIVER_YOKOHAMA, name: '横浜カスタマーセンター引取り' },
    { value: DELIVERY_METHOD_RECEIVER_OSAKA, name: '大阪カスタマーセンター引取り' },
    { value: DELIVERY_METHOD_RECEIVER_TOKYO_SHOWROOM, name: '東京ショールーム引取り' },
    { value: DELIVERY_METHOD_RECEIVER_OSAKA_SHOWROOM, name: '大阪ショールーム引取り' },
]

export const DELIVERY_TIME_SPECIFIED_FALSE = 0
export const DELIVERY_TIME_SPECIFIED_TRUE = 1
export const DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF = 2
export const DELIVERY_TIME_SPECIFIED_LIST = [
    { value: DELIVERY_TIME_SPECIFIED_FALSE, name: '指定なし（片道￥1,100～）' },
    { value: DELIVERY_TIME_SPECIFIED_TRUE, name: '指定あり（片道￥2,750～）' },
    { value: DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF, name: '指定あり（引取り）' },
]

export const RETURN_TIME_SPECIFIED_FALSE = 0
export const RETURN_TIME_SPECIFIED_TRUE = 1
export const RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF = 2
export const RETURN_TIME_SPECIFIED_LIST = [
    { value: RETURN_TIME_SPECIFIED_FALSE, name: '指定なし（片道￥1,100～）' },
    { value: RETURN_TIME_SPECIFIED_TRUE, name: '指定あり（片道￥2,750～）' },
    { value: RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF, name: '指定あり（引取り）' },
]

// 返却方法
export const RETURN_METHOD_DELIVER_YAMATO = 'deliver_yamato' // 宅配 ヤマト運輸
export const RETURN_METHOD_DELIVER_SAGAWA = 'deliver_sagawa' // 宅配 佐川急便
export const RETURN_METHOD_DELIVER_CHARTER = 'deliver_charter' // 宅配 チャーター便
export const RETURN_METHOD_DELIVER_OWN = 'deliver_own' // ルート便（契約者のみ）
export const RETURN_METHOD_RECEIVER_YOKOHAMA = 'receiver_yokohama' // 店舗受け取り 横浜
export const RETURN_METHOD_RECEIVER_OSAKA = 'receiver_osaka' // 店舗受け取り 大阪
export const RETURN_METHOD_RECEIVER_TOKYO_SHOWROOM = 'receiver_tokyo_showroom' // 店舗受け取り 東京ショールーム
export const RETURN_METHOD_RECEIVER_OSAKA_SHOWROOM = 'receiver_osaka_showroom' // 店舗受け取り 大阪ショールーム

export const RETURN_METHOD_TYPE_LIST = [
    { value: RETURN_METHOD_DELIVER_YAMATO, name: '宅配 ヤマト運輸' },
    { value: RETURN_METHOD_DELIVER_SAGAWA, name: '宅配 佐川急便' },
    { value: RETURN_METHOD_DELIVER_CHARTER, name: 'チャーター便' },
    { value: RETURN_METHOD_DELIVER_OWN, name: 'ルート便（契約者のみ）' },
    { value: RETURN_METHOD_RECEIVER_YOKOHAMA, name: '横浜カスタマーセンター引取り' },
    { value: RETURN_METHOD_RECEIVER_OSAKA, name: '大阪カスタマーセンター引取り' },
    { value: RETURN_METHOD_RECEIVER_TOKYO_SHOWROOM, name: '東京ショールームご返却' },
    { value: RETURN_METHOD_RECEIVER_OSAKA_SHOWROOM, name: '大阪ショールームご返却' },
]

export const DELIVERY_TIME_DETAIL_UNDECIDED = 'DELIVERY_TIME_DETAIL_UNDECIDED'
export const DELIVERY_TIME_DETAIL_AM = 'DELIVERY_TIME_DETAIL_AM'
export const DELIVERY_TIME_DETAIL_10_12 = 'DELIVERY_TIME_DETAIL_10_12'
export const DELIVERY_TIME_DETAIL_12_14 = 'DELIVERY_TIME_DETAIL_12_14'
export const DELIVERY_TIME_DETAIL_14_16 = 'DELIVERY_TIME_DETAIL_14_16'
export const DELIVERY_TIME_DETAIL_14_17 = 'DELIVERY_TIME_DETAIL_14_17'
export const DELIVERY_TIME_DETAIL_16_18 = 'DELIVERY_TIME_DETAIL_16_18'
export const DELIVERY_TIME_DETAIL_18_20 = 'DELIVERY_TIME_DETAIL_18_20'
export const DELIVERY_TIME_DETAIL_19_21 = 'DELIVERY_TIME_DETAIL_19_21'
// 納品希望時間指定
export const DELIVERY_TIME_DETAIL_LIST = [
    { value: DELIVERY_TIME_DETAIL_UNDECIDED, name: '未定' },
    { value: DELIVERY_TIME_DETAIL_AM, name: 'AM' },
    { value: DELIVERY_TIME_DETAIL_10_12, name: '10～12時' },
    { value: DELIVERY_TIME_DETAIL_12_14, name: '12～14時' },
    { value: DELIVERY_TIME_DETAIL_14_16, name: '14～16時' },
    { value: DELIVERY_TIME_DETAIL_14_17, name: '14～17時' },
    { value: DELIVERY_TIME_DETAIL_16_18, name: '16～18時' },
    { value: DELIVERY_TIME_DETAIL_18_20, name: '18～20時' },
    { value: DELIVERY_TIME_DETAIL_19_21, name: '19～21時' },
]
export const DELIVERY_TIME_DETAIL_LIST_CHARTER = [
    DELIVERY_TIME_DETAIL_AM,
    DELIVERY_TIME_DETAIL_14_16,
    DELIVERY_TIME_DETAIL_16_18,
    DELIVERY_TIME_DETAIL_18_20,
]
export const DELIVERY_TIME_DETAIL_LIST_YAMATO = [
    DELIVERY_TIME_DETAIL_AM,
    DELIVERY_TIME_DETAIL_14_16,
    DELIVERY_TIME_DETAIL_16_18,
    DELIVERY_TIME_DETAIL_18_20,
    DELIVERY_TIME_DETAIL_19_21,
]
export const DELIVERY_TIME_DETAIL_LIST_RECEIVER = [
    DELIVERY_TIME_DETAIL_10_12,
    DELIVERY_TIME_DETAIL_12_14,
    DELIVERY_TIME_DETAIL_14_17,
]

export const RETURN_TIME_DETAIL_UNDECIDED = 'RETURN_TIME_DETAIL_UNDECIDED'
export const RETURN_TIME_DETAIL_AM = 'RETURN_TIME_DETAIL_AM'
export const RETURN_TIME_DETAIL_10_12 = 'RETURN_TIME_DETAIL_10_12'
export const RETURN_TIME_DETAIL_12_14 = 'RETURN_TIME_DETAIL_12_14'
export const RETURN_TIME_DETAIL_14_16 = 'RETURN_TIME_DETAIL_14_16'
export const RETURN_TIME_DETAIL_14_17 = 'RETURN_TIME_DETAIL_14_17'
export const RETURN_TIME_DETAIL_16_18 = 'RETURN_TIME_DETAIL_16_18'
export const RETURN_TIME_DETAIL_18_20 = 'RETURN_TIME_DETAIL_18_20'
export const RETURN_TIME_DETAIL_19_21 = 'RETURN_TIME_DETAIL_19_21'
// 返却希望時間指定
export const RETURN_TIME_DETAIL_LIST = [
    { value: RETURN_TIME_DETAIL_UNDECIDED, name: '未定' },
    { value: RETURN_TIME_DETAIL_AM, name: 'AM' },
    { value: RETURN_TIME_DETAIL_10_12, name: '10～12時' },
    { value: RETURN_TIME_DETAIL_12_14, name: '12～14時' },
    { value: RETURN_TIME_DETAIL_14_16, name: '14～16時' },
    { value: RETURN_TIME_DETAIL_14_17, name: '14～17時' },
    { value: RETURN_TIME_DETAIL_16_18, name: '16～18時' },
    { value: RETURN_TIME_DETAIL_18_20, name: '18～20時' },
    { value: RETURN_TIME_DETAIL_19_21, name: '19～21時' },
]

export const RETURN_TIME_DETAIL_LIST_RECEIVER = [
    RETURN_TIME_DETAIL_UNDECIDED,
    RETURN_TIME_DETAIL_10_12,
    RETURN_TIME_DETAIL_12_14,
    RETURN_TIME_DETAIL_14_17,
]
export const RETURN_TIME_DETAIL_LIST_CHARTER = [
    RETURN_TIME_DETAIL_AM,
    RETURN_TIME_DETAIL_14_16,
    RETURN_TIME_DETAIL_16_18,
    RETURN_TIME_DETAIL_18_20,
]

// 搬入搬出サポート
export const CARRIED_SUPPORT_FALSE = 0
export const CARRIED_SUPPORT_TRUE = 1

export const CARRIED_SUPPORT_LIST = [
    { value: CARRIED_SUPPORT_FALSE, name: 'なし' },
    { value: CARRIED_SUPPORT_TRUE, name: 'あり(¥22,000~)' },
]

const DATE_TIME_FORMAT = 'YYYY-MM-DD H:mm'

export default class OrderHistory extends Model {
    constructor(data = null) {
        super()

        this.fillable = FILLABLE
        this.presents = PRESENTS

        this.id = 0
        this.orderId = 0
        this.couponId = null
        this.userId = 0
        this.version = 0
        this.userName = '' // 発注者氏名
        this.userEmail = '' // 発注者メールアドレス
        this.userPhone = '' // 電話番号
        this.orderCompanyName = '' // 御社名
        this.paymentName = ''
        this.usageDate = ''
        this.usageName = null
        this.usageDetail = ''
        this.deliveryDate = ''
        this.deliveryTimeSpecified = 0
        this.deliveryTimeDetail = ''
        this.deliveryPersonName = ''
        this.deliveryPersonTel = ''
        this.deliveryTargetPhoneNumber = ''
        this.deliveryMethod = ''
        this.deliveryTargetOther = ''
        this.returnDate = ''
        this.returnTimeSpecified = null
        this.returnTimeDetail = ''
        this.returnPersonName = ''
        this.returnPersonTel = ''
        this.returnMethod = ''
        this.returnTargetOther = ''
        this.remarks = ''
        this.totalPriceJpy = 0
        this.discountPriceJpy = 0
        this.boxCount = 0
        this.shippingFee = 0
        this.workingExpenses = 0
        this.discountTotalPriceJpy = 0
        this.status = ''
        this.responsiblePersonName = ''
        this.updatedUserType = ''
        this.quoteExpirationDate = ''
        this.orderPeriodDate = ''
        this.fixedDate = ''
        this.fixedDueDate = ''
        this.paymentDueDate = ''
        this.deliveryDueDate = ''
        this.rentalPeriod = ''
        this.rentalPeriodRate = 1
        this.extendedDate = ''
        this.purchaseOrderRemarks = ''
        this.quoteRemarks = ''
        this.isStockCheckOnly = 0
        this.usagePrefecture = ''
        this.carriedSupport = 0
        this.carryOutSupport = 0
        this.customerCode = ''

        this.createdAt = ''
        this.updatedAt = ''

        this.orderNumber = '' // 受注番号(8桁)
        this.user = new User()
        this.coupon = new Coupon()
        this.orderDeliveryAddress = new OrderDeliveryAddress()
        this.orderUserAddress = new UserAddress()
        this.orderItems = []
        this.orderNotListItems = []
        this.encryptCode = ''

        this.familyName = '' // 氏
        this.firstName = '' // 名
        this.taxJpy = 0 // 消費税
        this.userTypeDiscount = 0 // ユーザーごとの割引価格
        this.couponDiscount = 0 // クーポンの割引価格
        this.discountPriceJpyTax = 0 // 税込割引価格
        this.shippingFeeTax = 0 // 税込送料
        this.workingExpensesTax = 0 // 税込作業費

        this.pdfSelect = ''

        this.convertInt()

        this.arrayMap(
            new ArrayMappable(OrderItem).bind('orderItems'),
            new ArrayMappable(OrderNotListItem).bind('orderNotListItems')
        )
        if (data) {
            this.data = data
        }
    }

    get _model() {
        return 'OrderHistory'
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = this.converter.camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(this.converter.snakeToCamel(x.key)))
            .select((x) => {
                const key = this.converter.snakeToCamel(x.key)

                if (this[key] instanceof Number) {
                    x.value = Number(x.value)
                }

                if (this[key] && this[key].getPostable instanceof Function) {
                    x.value = new this[key].constructor(x.value)
                }

                if (x.key === 'order_items') {
                    x.value = linq
                        .from(x.value)
                        .select((x) => new OrderItem(x))
                        .toArray()
                }

                if (x.key === 'order_not_list_items') {
                    x.value = linq
                        .from(x.value)
                        .select((x) => new OrderNotListItem(x))
                        .toArray()
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    // 送料、消費税、込みの料金
    get fixTotalPrice() {
        return this.discountTotalPriceJpy.toLocaleString()
    }

    get usageNameText() {
        if (this.usageName === null) return ''
        return USAGE_NAME_LIST[this.usageName].name
    }

    get inputReturnDate() {
        return this.returnDate
    }
    set inputReturnDate(val) {
        this.returnDate = dateFormat(val, 'YYYY-MM-DD')
    }

    get inputUsageDate() {
        return this.usageDate
    }
    set inputUsageDate(val) {
        this.usageDate = dateFormat(val, 'YYYY-MM-DD')
    }

    get inputDeliveryDate() {
        return this.deliveryDate
    }
    set inputDeliveryDate(val) {
        this.deliveryDate = dateFormat(val, 'YYYY-MM-DD')
    }
    get inputQuoteExpirationDate() {
        return this.quoteExpirationDate
    }
    set inputQuoteExpirationDate(val) {
        this.quoteExpirationDate = dateFormat(val, 'YYYY-MM-DD')
    }
    get inputOrderPeriodDate() {
        return this.orderPeriodDate
    }
    set inputOrderPeriodDate(val) {
        let format = DATE_TIME_FORMAT
        if (!this.orderPeriodDate) {
            format = 'YYYY-MM-DD 11:00'
        }
        this.orderPeriodDate = dateFormat(val, format)
    }
    get inputFixedDate() {
        return this.fixedDate
    }
    set inputFixedDate(val) {
        this.fixedDate = dateFormat(val, 'YYYY-MM-DD')
    }
    get inputFixedDueDate() {
        return this.fixedDueDate
    }
    set inputFixedDueDate(val) {
        let format = DATE_TIME_FORMAT
        if (!this.fixedDueDate) {
            format = 'YYYY-MM-DD 11:00'
        }
        this.fixedDueDate = dateFormat(val, format)
    }
    get inputDeliveryDueDate() {
        return this.deliveryDueDate
    }
    set inputDeliveryDueDate(val) {
        this.deliveryDueDate = dateFormat(val, 'YYYY-MM-DD')
    }
    get inputPaymentDueDate() {
        return this.paymentDueDate
    }
    set inputPaymentDueDate(val) {
        let format = DATE_TIME_FORMAT
        if (!this.paymentDueDate) {
            format = 'YYYY-MM-DD 11:00'
        }
        this.paymentDueDate = dateFormat(val, format)
    }
    get inputExtendedDate() {
        return this.extendedDate
    }
    set inputExtendedDate(val) {
        this.extendedDate = dateFormat(val, 'YYYY-MM-DD')
    }

    get deliveryMethodName() {
        if (!this.deliveryMethod) return ''
        return DELIVERY_METHOD_TYPE_LIST.find((x) => x.value === this.deliveryMethod).name
    }

    get deliveryTimeSpecifiedName() {
        return DELIVERY_TIME_SPECIFIED_LIST.find(
            (x) => x.value === Number(this.deliveryTimeSpecified)
        ).name
    }

    get returnMethodName() {
        if (!this.returnMethod) return ''
        return RETURN_METHOD_TYPE_LIST.find((x) => x.value === this.returnMethod).name
    }

    get returnTimeSpecifiedName() {
        if (!this.returnTimeSpecified) return ''
        return RETURN_TIME_SPECIFIED_LIST.find((x) => x.value === this.returnTimeSpecified).name
    }

    // ユーザー側が見るステータス
    get orderStatusName() {
        if (!this.status) return ''
        return ORDER_STATUS_LIST.find((x) => x.value === this.status).name
    }

    // ユーザー側が見るステータス
    get userShowOrderStatusName() {
        if (!this.status) return ''
        return USER_ORDER_ORDER_STATUS_LIST.find((x) => x.value === this.status).name
    }

    // 納品希望時間
    get deliveryTimeDetailName() {
        if (!this.deliveryTimeDetail) return ''
        return DELIVERY_TIME_DETAIL_LIST.find((x) => x.value === this.deliveryTimeDetail).name
    }

    // 返却希望時間
    get returnTimeDetailName() {
        if (!this.returnTimeDetail) return ''
        const res = RETURN_TIME_DETAIL_LIST.find((x) => x.value === this.returnTimeDetail)
        if (res) {
            return res.name
        }
        return ''
    }

    // 搬入サポート
    get carriedSupportName() {
        const res = CARRIED_SUPPORT_LIST.find((x) => x.value === this.carriedSupport)
        if (res) {
            return res.name
        }
        return ''
    }

    // 搬出サポート
    get carryOutSupportName() {
        const res = CARRIED_SUPPORT_LIST.find((x) => x.value === this.carryOutSupport)
        if (res) {
            return res.name
        }
        return ''
    }

    get updatedUserTypeName() {
        if (!this.updatedUserType) return
        if (this.updatedUserType === 'admin') {
            return '管理者'
        }
        if (this.updatedUserType === 'user') {
            return '顧客'
        }
        if (this.updatedUserType === 'auto') {
            return '自動更新'
        }
    }

    get shippingFeeDisplay() {
        if (this.shippingFee) {
            return this.shippingFeeTax.toLocaleString()
        }

        // 在庫確認のみの場合
        if (this.isStockCheckOnly) {
            return '未定'
        }
        // 新規発注のチャーターの場合
        if (this.deliveryMethod === DELIVERY_METHOD_DELIVER_CHARTER) {
            return '未定'
        }
        if (
            this.status === OrderConstant.ORDER_STATUS_WSG_WAIT &&
            this.deliveryMethod === DELIVERY_METHOD_DELIVER_CHARTER
        ) {
            return '未定'
        }
        return this.shippingFeeTax.toLocaleString()
    }

    carriedSupportDisplay(value) {
        const res = CARRIED_SUPPORT_LIST.find((x) => x.value === Number(value))
        if (res) {
            return res.name
        }
        return ''
    }

    convertInt() {
        this.deliveryTimeSpecified = Number(this.deliveryTimeSpecified)
        this.returnTimeSpecified = Number(this.returnTimeSpecified)
    }

    dateFormatConvert() {
        this.usageDate = dateFormat(this.usageDate, 'YYYY-MM-DD')
        this.returnDate = dateFormat(this.returnDate, 'YYYY-MM-DD')
        this.deliveryDate = dateFormat(this.deliveryDate, 'YYYY-MM-DD')
    }

    setOldData(old) {
        linq.from(old).forEach((x) => {
            const key = this.converter.snakeToCamel(x.key)
            const word = 'order_user_address_'

            if (x.value) {
                if (x.key.indexOf(word) !== -1) {
                    const resKey = x.key.replace(word, '')
                    const c_resKey = this.converter.snakeToCamel(resKey)
                    this.orderUserAddress[c_resKey] = x.value
                    return
                }

                if (x.key === 'coupon_code') {
                    this.coupon.code = x.value
                    return
                }

                if (typeof this[key] === 'number') {
                    x.value = Number(x.value)
                }

                this[key] = x.value
            }
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/OrderHistory.js